/**
 * Nanokart TryOn Studio Frontend
 * Build version: 2025.03.07
 * 
 * Changes in this build:
 * - Increased image upload limit from 5MB to 20MB (backend handles compression)
 * - Rate limits and budget enforcement
 * - SDK integration fixes
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
